import CardLabelPreview from "@project/components/CardLabel/CardLabelPreview";
import ContentsTypes from "@shared/enums/contentsTypes";
import customTypes from "@project/enums/contentsCustomTypes.enum";
export const CardLabel = {
    label: "Carte label",
    type: customTypes.CARD_LABEL,
    Preview: CardLabelPreview,
    icon: "ballot",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Icône",
            key: "icon",
            type: ContentsTypes.ICON,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Description",
            key: "description",
            type: ContentsTypes.SHORT_TEXT,
            value: "",
        },
        {
            label: "Alignement",
            key: "alignment",
            type: ContentsTypes.SELECT,
            options: [
                { label: "À gauche", value: "left" },
                { label: "Centré", value: "center" },
            ],
            value: "center",
        },
    ],
};
